import React from "react";
import C from "../constants/colors";

const StatCard = ({ icon, label, value, sub, subColor, valueColor = C.primary }) => (
  <div className="ud-stat-card">
    <p style={{ fontSize: "0.625rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.12em", color: C.muted, marginBottom: "0.375rem" }}>
      {label}
    </p>
    <h2 style={{ fontSize: "1.875rem", fontWeight: 800, color: valueColor, letterSpacing: "-0.02em", margin: 0 }}>
      {value}
    </h2>
    {sub && (
      <p style={{ fontSize: "0.625rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", color: subColor || C.muted, marginTop: "0.5rem", marginBottom: 0 }}>
        {sub}
      </p>
    )}
    <i className={`${icon} ud-bg-icon`} style={{ color: C.primary }} />
  </div>
);

export default StatCard;
